import { call, put, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { TRANSLATION_REQUEST, TRANSLATION_UPDATE_REQUEST } from './actionTypes';
import {
  translationSuccess,
  translationFailure,
  translationUpdateSuccess,
  translationUpdateFailure,
} from './actions';
import DealerService from '../../services/DealerService';

function* fetchTranslation(action) {
  try {
    const translations = yield call(
      DealerService.getTranslations,
      action.payload.dealerId,
    );
    yield put(translationSuccess(translations));
  } catch (error) {
    yield put(translationFailure(error));
  }
}

function* updateTranslation(action) {
  try {
    const translations = yield call(
      DealerService.updateTranslations,
      action.payload.dealerId,
      action.payload.translations,
    );
    yield put(translationUpdateSuccess(translations));
    yield put(push(`/${action.payload.dealerId}/text`));
  } catch (error) {
    yield put(translationUpdateFailure(error));
  }
}

export function* translationsSaga() {
  yield takeEvery(TRANSLATION_REQUEST, fetchTranslation);
  yield takeEvery(TRANSLATION_UPDATE_REQUEST, updateTranslation);
}
